import set from 'lodash/set'
import get from 'lodash/get'
import isArray from 'lodash/isArray'
import isObject from 'lodash/isObject'
import alertMutations from '@/store/alerts/mutations.js'
import { appData } from '@/utils'
import { userDefaultState } from '@/store/state'

function addToList (state, payload, thing) {
	let things = state[ thing ]
	if (-1 === things.indexOf(payload)) {
		things.push(payload)
	}

	this._vm.$set(state, thing, things)
}

export default {
	...alertMutations,
	setBannerTitle (state, payload) {
		this._vm.$set(state, 'bannerTitle', payload)
	},
	loading (state, payload) {
		if (!payload) {
			return this._vm.$set(state, 'loading', [])
		}

		addToList.call(this, state, payload, 'loading')
	},
	fetching (state, payload) {
		addToList.call(this, state, payload, 'fetching')
	},
	fetched (state, payload) {
		let { fetching } = state

		const index = fetching.indexOf(payload)
		if (-1 !== index) {
			fetching.splice(index, 1)
			this._vm.$set(state, 'fetching', fetching)
		}

		addToList.call(this, state, payload, 'fetched')
	},
	doneFetching (state, payload) {
		let { fetching } = state
		if (!payload) {
			fetching = []
		} else {
			const index = fetching.indexOf(payload)
			if (-1 !== index) {
				fetching.splice(index, 1)
			}
		}

		this._vm.$set(state, 'fetching', fetching)
	},
	doneLoading (state, payload) {
		let { loading } = state
		if (!payload) {
			loading = []
		} else {
			const index = loading.indexOf(payload)
			if (-1 !== index) {
				loading.splice(index, 1)
			}
		}

		this._vm.$set(state, 'loading', loading)
	},
	resetUser (state) {
		this._vm.$set(state, 'user', userDefaultState())
	},
	setUser (state, user) {
		if (!state.user.id) {
			const defaults = { ...get(state, 'user.onboarding', {}) }
			let onboarding = get(user, 'onboarding', {})
			if (!isObject(onboarding)) {
				onboarding = {}
			}

			Object.keys(defaults).forEach(k => {
				if (!(k in onboarding)) {
					onboarding[k] = defaults[k]
				}
			})

			set(user, 'onboarding', onboarding)
		}

		this._vm.$set(state, 'user', user)
	},
	setUserAttribute (state, { key, value }) {
		const user = { ...state.user }
		const previousVal = get(user, key)

		if (isArray(previousVal)) {
			let val = []
			if (-1 === previousVal.indexOf(value)) {
				val = [ ...previousVal, value ]
			} else {
				val = [ ...previousVal.filter((v) => {
					return v !== value
				}) ]
			}

			value = val
		}

		set(user, key, value)

		this._vm.$set(state, 'user', user)
	},
	setApiKey (state, payload) {
		appData.set('key', payload)
		this._vm.$set(state, 'apiKey', payload)
	},
	incrementVisits (state, path) {
		const visits = get(state, `visits.${path}`, 0)
		this._vm.$set(state.visits, path, visits + 1)
	},
	// For manual resetting via browser console.
	resetVisits (state) {
		this._vm.$set(state, 'visits', {})
	},
}
